import { render } from "./Course.vue?vue&type=template&id=37b1f0cc&scoped=true"
import script from "./Course.vue?vue&type=script&lang=js"
export * from "./Course.vue?vue&type=script&lang=js"

import "./Course.vue?vue&type=style&index=0&id=37b1f0cc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-37b1f0cc"

export default script